import { DestroyRef, inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { map, shareReplay } from "rxjs/operators";
import { environment } from "../../../environments/environment";
import { GroupItemModel } from "../../shared/modules/loren-hierarchy-selector/group.interface";
import { Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class AssetGroupService {
  private readonly destroyRef = inject(DestroyRef);
  private readonly http = inject(HttpClient);

  groups$ = this.http.get<{ items: GroupItemModel[] }>(`${environment.apiServerUrl}/asset-groups`).pipe(
    takeUntilDestroyed(this.destroyRef),
    map(({ items }) => items),
    map((groups) => groups.sort((a, b) => {
      if (a?.name > b?.name) {
        return 1;
      }

      if (a?.name < b?.name) {
        return -1;
      }

      return 0;
    })),
    shareReplay({bufferSize: 1, refCount: true}),
  )

  get all(): Observable<GroupItemModel[]> {
    return this.groups$;
  }
}